import React from 'react';
import {Link} from 'react-router-dom';
import Input from './Input/Input';
import classes from '../styles/Login.module.css';
import Button from './Button/Button';
import fbLogo from '../../../images/facebook-icon.svg';
import googleLogo from '../../../images/google-icon.svg';
import {BUTTON_TYPES} from './Button/buttonTypes';

const LoginComponent = ({
    formData: {
      email,
      password
    },
    loginError,
    onChange,
    onSubmit,
    googleSignIn,
    fbSignIn
  }) => {
  return (
      <div>
        <div className={classes.AuthBy}>
          <Button icon={fbLogo} styles={{marginBottom: '7px'}} onClick={fbSignIn}>
            Login with Facebook
          </Button>
          <Button icon={googleLogo} onClick={googleSignIn}>
            Login with Google
          </Button>
        </div>
        <div className={classes.Separator}>
          <div className={classes.HLine}></div>
          <span className={classes.TextInLine}>or login with email</span>
          <div className={classes.HLine}></div>
        </div>
        {loginError ?
            <div className={classes.FormError}>
              <span>Incorrect password or email</span>
            </div>
            : null
        }
        <div className={classes.marginBottom26}>
          <Input
              name='email'
              label='Email'
              id='email'
              placeholder='Enter your email'
              value={email.value}
              onChange={onChange}
              error={email.touched && !email.valid || loginError}
          />
        </div>
        <div>
          <Input
              name='password'
              label='Password'
              id='password'
              type='password'
              placeholder='*******'
              value={password.value}
              onChange={onChange}
              error={password.touched && !password.valid || loginError}
          />
        </div>
        <div className={classes.Button}>
          <Button type={BUTTON_TYPES.PRIMARY} onClick={onSubmit}>
            Sign In
          </Button>
        </div>
        <div className={classes.Link}>
          <Link to='/forgotPassword'>Forgot password?</Link>
        </div>
        {/* <div className={classes.Registry}>
          <span>Don’t have an account?</span>
          <Link to='signUp' className={classes.RegistryLink}>Create one</Link>
        </div> */}
      </div>
  );
};

export default LoginComponent;